// src/pages/financeiro/AssinaturaSearch.js
import React, { useEffect, useState } from 'react';
import { FaSortDown, FaSortUp } from 'react-icons/fa';

import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalTable from '../../components/modalForm/ModalTable';
import { useAssinatura } from '../../contexts/financeiro/AssinaturaContext';
import { formatCurrency } from '../../utils/numberUtils';
import { statusClienteOptions } from '../../models/financeiro/Assinatura';
import LazyLoading from '../../components/modalForm/LazyLoading';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const AssinaturaSearch = ({ show, onHide, onSelectCobranca }) => {
  const { cobrancas } = useAssinatura();
  const [filter, setFilter] = useState('');
  const [sortField, setSortField] = useState('id');
  const [sortDirection, setSortDirection] = useState('asc');

  useEffect(() => {
    if (show) {
      setFilter('');
    }
  }, [show]);

  if (!show) return null;

  const normalizedFilter = filter.trim().toLowerCase();
  const filteredCobrancas = (cobrancas || []).filter((item) => {
    const nome = item.cliente?.pessoa?.nome || '';
    const descricao = item.descricao || '';
    return nome.toLowerCase().includes(normalizedFilter)
      || descricao.toLowerCase().includes(normalizedFilter)
      || String(item.id).includes(normalizedFilter);
  });

  const sortedCobrancas = [...filteredCobrancas].sort((a, b) => {
    const direction = sortDirection === 'asc' ? 1 : -1;

    if (sortField === 'cliente') {
      return (a.cliente?.pessoa?.nome || '').localeCompare(b.cliente?.pessoa?.nome || '') * direction;
    }

    if (sortField === 'valor') {
      return ((a.valor || 0) - (b.valor || 0)) * direction;
    }

    return ((a.id || 0) - (b.id || 0)) * direction;
  });

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
      return;
    }

    setSortField(field);
    setSortDirection('asc');
  };

  const selecionar = (item) => {
    onSelectCobranca(item);
    onHide();
  };

  return (
    <ModalContainer show={show} largura="800px" variant="busca" onHide={onHide}>
      <ModalHeader title="Buscar Assinatura" onHide={onHide} />

      <ModalBody>
        <div className="mb-3">
          <ModalSearchBar
            type="text"

            placeholder="Filtrar por cliente, descrição ou código..."
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            autoFocus
          />
        </div>

        <LazyLoading
          items={sortedCobrancas}
          resetKey={`${filter}|${sortField}|${sortDirection}`}
        >
          {({ containerRef, handleScroll, visibleItems }) => (
            <ModalTable
              containerRef={containerRef}
              containerStyle={{ maxHeight: '55vh', overflowY: 'auto' }}
              onContainerScroll={handleScroll}
            >
              <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                <tr>
                  <th style={{width:'40px'}} aria-sort={sortField === 'id' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                    <button type="button" onClick={() => handleSort('id')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }}>
                      Id {sortField === 'id' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                    </button>
                  </th>
                  <th aria-sort={sortField === 'cliente' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                    <button type="button" onClick={() => handleSort('cliente')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }}>
                      Cliente {sortField === 'cliente' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                    </button>
                  </th>
                  <th style={{width:'80px'}} aria-sort={sortField === 'valor' ? (sortDirection === 'asc' ? 'ascending' : 'descending') : 'none'}>
                    <button type="button" onClick={() => handleSort('valor')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }}>
                      Valor {sortField === 'valor' && (sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />)}
                    </button>
                  </th>
                  <th style={{width:'40px'}}>Dia</th>
                  <th style={{width:'60px'}}>Hora</th>
                  <th style={{width:'80px'}}>Status</th>
                  <th style={{width:'100px'}} className="modal-select-column">Selecionar</th>
                </tr>
              </thead>
              <tbody>
                {visibleItems.map((item) => (
                  <tr key={item.id} onDoubleClick={() => selecionar(item)}>
                    <td style={{textAlign: 'center'}}>{item.id}</td>
                    <td>{item.cliente?.pessoa?.nome || '-'}</td>
                    <td style={{textAlign: 'right'}}>{formatCurrency(item.valor)}</td>
                    <td style={{textAlign: 'center'}}>{item.diaVencimento}</td>
                    <td style={{textAlign: 'center'}}>{item.horarioCobranca?.substring(0, 5)}</td>
                    <td>{statusClienteOptions.find((status) => status.value === item.statusCliente)?.label || '-'}</td>
                    <td className="modal-select-column">
                      <ModalSelectButton type="button" className="btn btn-outline-secondary btn-sm" style={{ padding: '2px 6px' }} onClick={() => selecionar(item)} label={item.cliente?.pessoa?.nome || '-'} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </ModalTable>
          )}
        </LazyLoading>
      </ModalBody>

      <ModalFooter>
        <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">Fechar</ModalActionButton>
      </ModalFooter>
    </ModalContainer>
  );
};

export default AssinaturaSearch;
